import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { TextBody, Button, Col, Row, TextTitle, } from '../../atoms';
import { useBreakpoints } from '../../hooks';
export const CtaBanner = memo(({ title, text, variant, ctaLabel, onCtaPress }) => {
    const { breakpoints } = useBreakpoints(500);
    /**
     * Methods
     */
    const onCtaPressed = useCallback(() => {
        onCtaPress();
    }, [onCtaPress]);
    /**
     * DOM
     */
    const backgroundColor = theme.color.background[variant];
    const buttonVariant = variant === 'info'
        ? 'secondary'
        : variant === 'success'
            ? 'primary'
            : 'secondary';
    const textColor = variant === 'info' ? 'info' : 'primary';
    return (_jsxs(Row.LR, { style: [
            $.container,
            breakpoints.LESS_THAN_M && $.container_M,
            { backgroundColor },
        ], children: [_jsxs(Col.L, { style: $.content, children: [_jsx(TextTitle, { small: true, color: textColor, children: title }), _jsx(TextBody, { color: textColor, numberOfLines: 2, ellipsizeMode: "tail", children: text })] }), _jsx(Button, { variant: buttonVariant, label: ctaLabel, onPress: onCtaPressed, size: "sm" })] }));
});
const $ = StyleSheet.create({
    container: {
        paddingVertical: theme.spacing['4'],
        paddingHorizontal: theme.spacing['6'],
        borderRadius: Number(theme.radius.md),
        rowGap: theme.spacing['4'],
        flexWrap: 'wrap',
    },
    container_M: {
        paddingHorizontal: theme.spacing['4'],
    },
    content: {
        // RNW forces a flex-shrink: 0 on all <View> preventing normal text wrapping
        flexShrink: 1,
        rowGap: theme.spacing['1'],
        marginRight: theme.spacing['1'],
    },
});
